import script from "./VehicleRegistrationFullComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehicleRegistrationFullComponent.vue?vue&type=script&setup=true&lang=ts"

import "./VehicleRegistrationFullComponent.vue?vue&type=style&index=0&id=3a764fbd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a764fbd"]])

export default __exports__